import {
  Navigate,
  Outlet,
  useLocation,
  useOutletContext,
} from 'react-router-dom';
import { getUser } from 'src/utils/authStorage';

const PrivateRoute = () => {
  const location = useLocation();
  const userData = getUser();
  const outletContext = useOutletContext();

  // Check both authentication and role in one pass
  if (!userData || !userData.roles?.includes('candidate')) {
    return <Navigate to="/login" replace />;
  }

  // Only allow direct login users to access change password
  if (
    location.pathname === '/change-password' &&
    userData.identityProvider === 'google'
  ) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet context={outletContext} />;
};

export default PrivateRoute;
